import { GivingPersonProvider } from "../hooks/useGivingPersonContext"
import { DonationsSummaryProvider } from "../hooks/useDonationSummaryContext"
import { DonationHistoryInitializer } from "./DonationHistoryInitializer"

export default function ProfileContextProviders({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <GivingPersonProvider>
      <DonationsSummaryProvider>
        <DonationHistoryInitializer>{children}</DonationHistoryInitializer>
      </DonationsSummaryProvider>
    </GivingPersonProvider>
  )
}
